import { Component, OnInit } from '@angular/core';
import { Router,RouterModule} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  alertCount:any = 0;
  appDay:any;
  appTime:any;
  appDate:any;
  appLocname:any;
  appLocadd1:any;
  appLocadd2:any;
  appLoccity:any;
  appLocstate:any;
  appLoczip:any;
  locPhn:any;
  announcements:any=[];
  animate:Boolean = false;
   monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
  curMonth =this.monthNames[new Date().getMonth()] +" "+ new Date().getFullYear();
   d = new Date();
   preMonth:any;
   track:Boolean = true;
   track1:Boolean = true;
   curtrackreported:any =0;
   curtrackauthorized:any;
   curcompreported:any =0;
   curcompauthorized:any = Math.floor(this.loginService.monthlyBenefit/Number(this.loginService.maxWage));
   prevtrackreported:any =0;
   prevtrackauthorized:any;
   prevcompreported:any =0;
   prevtrackverified:any ='_';
   curtrackverified:any ='_';
   prevcompverified:any ='_';
   curcompverified:any ='_';
   prevnonComplaince:any = null;
   curnonComplaince:any = null;
   prevreasonType:any = null;
   curreasonType:any = null;
   key:string = sha256(ServerConstantsService.serverConstants.privateKey).toString();

  constructor(public router:Router,public toastService:ToastrService, public loginService:LoginService) { }

  ngOnInit() {
    this.load();   
    this.d.getMonth() === 0 ? this.preMonth = this.monthNames[11] +" "+ (new Date().getFullYear() -1 ) : this.preMonth = this.monthNames[this.d.getMonth() -1] +" "+ new Date().getFullYear();
  }
  navigate(value){
    if(value == 'participation' && CryptoJS.AES.decrypt(sessionStorage.getItem('status'), this.key).toString(CryptoJS.enc.Utf8) == 'SNAP RTW/Workfare'){
      this.router.navigate(['participation/workfare']);
    }
    else{
      this.router.navigate([value]);
    }
  }
  load(){
    let request = {
      perId:parseInt(CryptoJS.AES.decrypt(sessionStorage.getItem('id'), this.key).toString(CryptoJS.enc.Utf8))
    }
    this.loginService.loaddashboard(request).subscribe((data:Array<Object>)=>{
      this.alertCount = data[1]['@alertCount'];
      if(data[1]['@appointment'] != null){
        this.appDay = data[1]['@appointment'].split(',')[2];
        this.appTime = data[1]['@appointment'].split(',')[1];
        this.appDate = data[1]['@appointment'].split(',')[0];
        this.appLocname = data[1]['@appointment'].split(',')[3];
        this.appLocadd1 = data[1]['@appointment'].split(',')[4];
        this.appLocadd2 = data[1]['@appointment'].split(',')[5];
        this.appLoccity = data[1]['@appointment'].split(',')[6];
        this.appLocstate = data[1]['@appointment'].split(',')[7];
        this.appLoczip = data[1]['@appointment'].split(',')[8];
        this.locPhn = "(" + data[1]['@appointment'].split(',')[9].slice(0,3) + ") "+ data[1]['@appointment'].split(',')[9].slice(3,6)+"-"+ data[1]['@appointment'].split(',')[9].slice(6);
        
      }
      this.announcements = data[0];
      if(data[1]['@curtrackauthorized'] == null){
        this.track = false;
      }
      if(data[1]['@prevtrackauthorized'] == null){
        this.track1 = false;
      }
      if(data[1]['@curtrackreported'] !=null){
        this.curtrackreported = data[1]['@curtrackreported'];
      }
      this.curtrackauthorized = data[1]['@curtrackauthorized'];
      this.curcompauthorized = Math.floor(Number(CryptoJS.AES.decrypt(sessionStorage.getItem('benefit'), this.key).toString(CryptoJS.enc.Utf8))/Number(CryptoJS.AES.decrypt(sessionStorage.getItem('maxwage'), this.key).toString(CryptoJS.enc.Utf8)));
      if(data[1]['@curcompreported'] != null){
        this.curcompreported = data[1]['@curcompreported'];
      }
      if(data[1]['@curnonComplaince'] != null){
        this.curnonComplaince = 'Approved';
      }
      if(data[1]['@prevnonComplaince'] != null){
        this.prevnonComplaince = 'Approved';
      }
      if(data[1]['@curreasonType'] != null){
        if(this.loginService.staticData.get("NonCompReasonDesc").find(obj => obj.value == data[1]['@curreasonType'])){
          this.curreasonType = 'Good Cause';
        }
        else{
          this.curreasonType = 'Exemption';
        }
      }
      if(data[1]['@prevreasonType'] != null){
        if(this.loginService.staticData.get("NonCompReasonDesc").find(obj => obj.value == data[1]['@prevreasonType'])){
          this.prevreasonType = 'Good Cause';
        }
        else{
          this.prevreasonType = 'Exemption';
        }
      }
      if(data[1]['@prevcompreported']){
        this.prevcompreported = data[1]['@prevcompreported'];
      }
      if(data[1]['@prevtrackreported']){
        this.prevtrackreported = data[1]['@prevtrackreported'];
      }
      if(data[1]['@curtrackverified'] != null){
        this.curtrackverified = data[1]['@curtrackverified'];
      }
      if(data[1]['@prevtrackverified'] != null){
        this.prevtrackverified = data[1]['@prevtrackverified'];
      }
      if(data[1]['@curcompverified'] != null){
        this.curcompverified = data[1]['@curcompverified'];
      }
      if(data[1]['@prevcompverified'] != null){
        this.prevcompverified = data[1]['@prevcompverified'];
      }
      this.prevtrackauthorized = data[1]['@prevtrackauthorized'];
      setTimeout(()=>{
        if(document.getElementById('annc').scrollHeight > 200){
          this.animate = true;
        }
        else{
          this.animate = false;
        }
      },5000)
    },error=>{
      this.toastService.error('Unable to load dashboard','My Dashboard');
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts